<p-menubar [model]="items">
    <ng-template pTemplate="start">
        <div style="background-color: var(--primary-500); padding: 6px 20px; margin-right: 10px; cursor: pointer; background-clip: content-box; display: flex;" routerLink="home">
            <img src="assets/navbar-component-images/Logo.svg" alt="logo">
        </div>
    </ng-template>

    <ng-template pTemplate="end">
        <div class="right">     
            <div class="icons">
                <a class="icon">
                    <img src="assets/navbar-component-images/entypo_help.svg" alt=""> 
                </a>
                <a class="icon" *ngIf="!isLogin">
                    <img src="assets/navbar-component-images/Avatar_notsignin.png" alt="">
                </a>
                <div class="if-login" *ngIf="isLogin">
                    <div class="icon">
                        <img src="assets/navbar-component-images/Avatar.png" alt="">
                        <div class="circle">{{username?.charAt(0)?.toUpperCase()}}</div>
                    </div>       
                    <p>{{username}}</p>
                    <img src="assets/navbar-component-images/Logout.svg" alt="" (click)="logout()">
                </div>
            </div>
            <div class="login" *ngIf="!isLogin">
                <p-button label="Login" (onClick)="showDialog()" [style]="{'padding': '8px 20px'}"></p-button>
            </div>
        </div>
    </ng-template>
</p-menubar>
<!-- <div style="width: 100%; padding-left: 181px; gap: 10px;" class="marker">
    <div style="display: flex; width: 113px; justify-content: center;">
        <img routerLink="home" routerLinkActive="active" src="assets/navbar-component-images/Marker.svg">
    </div>
    <div style="display: flex; width: 101px; justify-content: center">
        <img routerLink="map" routerLinkActive="active" src="assets/navbar-component-images/Marker.svg">
    </div>
    <div style="display: flex; width: 180px; justify-content: center">
        <img routerLink="web-scraping" routerLinkActive="active" src="assets/navbar-component-images/Marker.svg">
    </div>
    <div style="width: 18px;"></div>
    <div style="display: flex; width: 187px; justify-content: center">
        <img routerLink="search" routerLinkActive="active" src="assets/navbar-component-images/Marker.svg">
    </div>
    <div style="display: flex; width: 98px; justify-content: center">
        <img routerLink="nlp" routerLinkActive="active" src="assets/navbar-component-images/Marker.svg">
    </div>
    <div style="width: 18px;"></div>
</div> -->

<p-dialog 
    [(visible)]="visible"
    [style]="{
        width: '506px', 
        height: '589px'
    } " 
    [showHeader]="false" 
    [modal]="true" 
    [draggable]="false" 
    [resizable]="false" 
    [dismissableMask]="true"
    (keyup.enter)="closeDialog()"
>
    <div class="login-form">
        <div style="background-color: var(--primary-500); margin-top: 2.5rem; cursor: pointer; background-clip: content-box; height: 6rem; width: fit-content;" routerLink="home">
            <img src="assets/navbar-component-images/Logo.svg" alt="logo" style="width: auto; height: 100%;">
        </div>
        <div class="line">
            <label for="email">Email</label>
            <input pInputText type="text" class="p-inputtext-md" placeholder="Example@email.com" id="email" [style]="{ borderRadius:'12px' }" [(ngModel)]="email" />
        </div>
        <div class="line">
            <label for="password">Password</label>
            <p-password [(ngModel)]="password" [feedback]="false" [toggleMask]="true" placeholder="At least 8 characters" id="password" [inputStyle]="{borderRadius:'12px' , width:'100%'}" [style]="{ width:'100%' }"></p-password>
        </div>
        <div class="forget-password">
            <a href="#">Forgot Password?</a>
        </div>
        <div class="sign-in">
            <button class="sign-in-button" (click)="closeDialog()">
                Sign in
            </button>
        </div>
        <div class="no-account-line">
            Don't you have an account? <a href="#">Sign up</a>
        </div>
    </div>
</p-dialog>
<p-toast></p-toast>
